import type { ConditionEvaluationObject } from '@unifyapps/defs/types/conditionEvaluationObject';
import { useCallback } from 'react';
import { useEvaluateConditionalOperator } from '../../../hooks/useComputeConditionEvaluationGetter';
import { useDSCUseReactiveComputeContext } from '../context/selectors';

export function useIsDataSourceDisabled() {
  // TODO: NEED TO FIND BETTER WAY TO FIND DISABLED DATASOURCE'S
  const { context } = useDSCUseReactiveComputeContext();
  const { evaluateConditionalOperator } = useEvaluateConditionalOperator();

  const getIsDisabled = useCallback(
    ({ disabled }: { disabled?: ConditionEvaluationObject }) => {
      return evaluateConditionalOperator({
        conditionEvaluationObj: disabled,
        context,
      });
    },
    [evaluateConditionalOperator, context],
  );

  return { getIsDisabled };
}
